import { render, staticRenderFns } from "./IlsEasySettingsPermissions.vue?vue&type=template&id=6f5943a2&"
import script from "./IlsEasySettingsPermissions.vue?vue&type=script&lang=js&"
export * from "./IlsEasySettingsPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports